import { Component } from '@angular/core';

@Component({
  selector: 'adminapp-summary-anti-virus-version-report',
  templateUrl: './summary-anti-virus-version-report.component.html',
  styleUrls: ['./summary-anti-virus-version-report.component.scss']
})
export class SummaryAntiVirusVersionReportComponent {

  constructor() { }
}
